// extracted by mini-css-extract-plugin
module.exports =  {"map":"Skeleton-Skeleton-map-e16ed720"};